// extracted by css-extract-rspack-plugin
export default {"editHeader":"pVhFy SoFw4","editHeaderButtons":"hCzan","editHeaderButton":"g9UGe","saveButton":"U7czS g9UGe","cancelButton":"J3hhk g9UGe"};